<template>
    <div :class="clContainer()">
        <span v-if="label" :class="clSub('label', 'label')">{{label}}</span>

        <div v-if="alerts.length" :class="clSub('errors')">
            <div v-for="(alert, index) in alerts.filter(a => a.type == 'error')" :class="clSub('error')" :key="index">
                {{ alert.text }}
            </div>
        </div>
        
        <div class="list_of_checks">
            <slot :state="state" :data="childrenData" :childChanged="childChanged" :changed="dataChanged" :set="set"></slot>
        </div>
    </div>
</template>

<script>
import Base from "./Base";
import HasEditableChildren from "./Mixins/HasEditableChildren";

export default {
    extends: Base,
    mixins: [ HasEditableChildren ],
    props: {
        typeClass: {
            type: String,
            default: 'group'
        }
    },
    computed: {
        formData() {
            return this.childrenData;
        }
    }
}
</script>